// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 响应式设计样式 */

/* 基础响应式断点 */
@media (max-width: 768px) {
  /* 移动端基础样式 */
  body {
    font-size: 14px;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
  }

  /* 禁用选择和复制（移动端优化） */
  * {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* 允许输入框选择 */
  input, textarea, [contenteditable] {
    -webkit-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
    user-select: auto;
  }

  /* 滚动优化 */
  body {
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  /* Ant Design 组件响应式优化 */
  .ant-card {
    border-radius: 8px !important;
    margin: 8px 0 !important;
  }

  .ant-btn {
    border-radius: 6px !important;
    min-height: 40px !important;
    font-size: 14px !important;
    touch-action: manipulation;
  }

  .ant-input {
    border-radius: 6px !important;
    min-height: 40px !important;
    font-size: 16px !important; /* 防止 iOS 缩放 */
  }

  .ant-table {
    font-size: 12px !important;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 8px !important;
  }

  .ant-modal {
    max-width: 95% !important;
    margin: 20px auto !important;
  }

  .ant-modal-content {
    border-radius: 8px !important;
  }

  .ant-form-item {
    margin-bottom: 16px !important;
  }

  .ant-form-item-label > label {
    font-size: 14px !important;
  }

  .ant-tag {
    border-radius: 4px !important;
    font-size: 12px !important;
    padding: 2px 6px !important;
  }

  .ant-space {
    flex-wrap: wrap !important;
  }

  .ant-divider {
    margin: 12px 0 !important;
  }

  .ant-select {
    width: 100% !important;
  }

  .ant-select-selector {
    min-height: 40px !important;
    border-radius: 6px !important;
  }

  .ant-picker {
    width: 100% !important;
    min-height: 40px !important;
    border-radius: 6px !important;
  }

  /* 表格响应式 */
  .ant-table-wrapper {
    overflow-x: auto;
  }

  .ant-table-container {
    min-width: 600px;
  }

  /* 卡片网格布局 */
  .ant-row {
    margin: 0 -8px !important;
  }

  .ant-col {
    padding: 0 8px !important;
  }

  /* 抽屉优化 */
  .ant-drawer-content {
    background: #161b22 !important;
  }

  .ant-drawer-header {
    background: #161b22 !important;
    border-bottom: 1px solid #30363d !important;
  }

  .ant-drawer-title {
    color: #e6edf3 !important;
  }

  .ant-drawer-close {
    color: #e6edf3 !important;
  }
}

/* 平板设备 */
@media (min-width: 769px) and (max-width: 1024px) {
  .ant-card {
    margin: 12px 0 !important;
  }

  .ant-btn {
    min-height: 44px !important;
  }

  .ant-input {
    min-height: 44px !important;
  }
}

/* 大屏幕优化 */
@media (min-width: 1025px) {
  .ant-card {
    margin: 16px 0 !important;
  }
}

/* 横屏优化 */
@media (max-width: 768px) and (orientation: landscape) {
  .ant-modal {
    margin: 10px auto !important;
  }

  .ant-btn {
    min-height: 36px !important;
  }

  .ant-input {
    min-height: 36px !important;
  }
}

/* 小屏幕手机优化 */
@media (max-width: 480px) {
  .ant-btn {
    font-size: 13px !important;
    padding: 8px 12px !important;
  }

  .ant-card {
    margin: 6px 0 !important;
  }

  .ant-space-item {
    margin-bottom: 8px !important;
  }

  .ant-table {
    font-size: 11px !important;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 6px !important;
  }
}

/* 触摸设备优化 */
@media (hover: none) and (pointer: coarse) {
  .ant-btn:hover {
    background-color: inherit !important;
  }

  .ant-list-item:hover {
    background-color: inherit !important;
  }

  .ant-table-tbody > tr:hover > td {
    background-color: inherit !important;
  }

  .ant-card:hover {
    box-shadow: inherit !important;
  }
}

/* 高分辨率屏幕优化 */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .ant-card {
    border-width: 0.5px !important;
  }

  .ant-btn {
    border-width: 0.5px !important;
  }
}

/* 暗黑主题响应式优化 */
@media (max-width: 768px) {
  .ant-card {
    background: #161b22 !important;
    border: 1px solid #30363d !important;
  }

  .ant-btn {
    border: 1px solid #30363d !important;
  }

  .ant-input {
    background: #21262d !important;
    border: 1px solid #30363d !important;
    color: #e6edf3 !important;
  }

  .ant-select-selector {
    background: #21262d !important;
    border: 1px solid #30363d !important;
    color: #e6edf3 !important;
  }

  .ant-modal-content {
    background: #161b22 !important;
  }

  .ant-modal-header {
    background: #161b22 !important;
    border-bottom: 1px solid #30363d !important;
  }

  .ant-modal-title {
    color: #e6edf3 !important;
  }

  .ant-modal-body {
    color: #e6edf3 !important;
  }
}

/* 响应式工具类 */
.responsive-hide-mobile {
  display: block;
}

.responsive-show-mobile {
  display: none;
}

@media (max-width: 768px) {
  .responsive-hide-mobile {
    display: none !important;
  }

  .responsive-show-mobile {
    display: block !important;
  }
}

.responsive-hide-tablet {
  display: block;
}

.responsive-show-tablet {
  display: none;
}

@media (min-width: 769px) and (max-width: 1024px) {
  .responsive-hide-tablet {
    display: none !important;
  }

  .responsive-show-tablet {
    display: block !important;
  }
}

/* 容器响应式 */
.responsive-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
}

@media (max-width: 768px) {
  .responsive-container {
    padding: 0 12px;
  }
}

@media (max-width: 480px) {
  .responsive-container {
    padding: 0 8px;
  }
}

/* 网格响应式 */
.responsive-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

@media (max-width: 768px) {
  .responsive-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .responsive-grid {
    gap: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ,YAAY;AACZ;EACE,YAAY;EACZ;IACE,eAAe;IACf,8BAA8B;IAC9B,wCAAwC;EAC1C;;EAEA,mBAAmB;EACnB;IACE,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA,YAAY;EACZ;IACE,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA,SAAS;EACT;IACE,iCAAiC;IACjC,4BAA4B;EAC9B;;EAEA,uBAAuB;EACvB;IACE,6BAA6B;IAC7B,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B,EAAE,cAAc;EAC5C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA,UAAU;EACV;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,WAAW;EACX;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,SAAS;EACT;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,SAAS;AACT;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,UAAU;AACV;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,SAAS;AACT;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,YAAY;AACZ;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,uBAAuB;EACzB;AACF;;AAEA,WAAW;AACX;EACE;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,aAAa;AACb;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA,cAAc;AACd;EACE;IACE,8BAA8B;IAC9B,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;IAC9B,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,WAAW;AACX;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,UAAU;AACV;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,UAAU;AACV;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,QAAQ;EACV;AACF","sourcesContent":["/* 响应式设计样式 */\n\n/* 基础响应式断点 */\n@media (max-width: 768px) {\n  /* 移动端基础样式 */\n  body {\n    font-size: 14px;\n    -webkit-text-size-adjust: 100%;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  /* 禁用选择和复制（移动端优化） */\n  * {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n\n  /* 允许输入框选择 */\n  input, textarea, [contenteditable] {\n    -webkit-user-select: auto;\n    -moz-user-select: auto;\n    -ms-user-select: auto;\n    user-select: auto;\n  }\n\n  /* 滚动优化 */\n  body {\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n  }\n\n  /* Ant Design 组件响应式优化 */\n  .ant-card {\n    border-radius: 8px !important;\n    margin: 8px 0 !important;\n  }\n\n  .ant-btn {\n    border-radius: 6px !important;\n    min-height: 40px !important;\n    font-size: 14px !important;\n    touch-action: manipulation;\n  }\n\n  .ant-input {\n    border-radius: 6px !important;\n    min-height: 40px !important;\n    font-size: 16px !important; /* 防止 iOS 缩放 */\n  }\n\n  .ant-table {\n    font-size: 12px !important;\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    padding: 8px !important;\n  }\n\n  .ant-modal {\n    max-width: 95% !important;\n    margin: 20px auto !important;\n  }\n\n  .ant-modal-content {\n    border-radius: 8px !important;\n  }\n\n  .ant-form-item {\n    margin-bottom: 16px !important;\n  }\n\n  .ant-form-item-label > label {\n    font-size: 14px !important;\n  }\n\n  .ant-tag {\n    border-radius: 4px !important;\n    font-size: 12px !important;\n    padding: 2px 6px !important;\n  }\n\n  .ant-space {\n    flex-wrap: wrap !important;\n  }\n\n  .ant-divider {\n    margin: 12px 0 !important;\n  }\n\n  .ant-select {\n    width: 100% !important;\n  }\n\n  .ant-select-selector {\n    min-height: 40px !important;\n    border-radius: 6px !important;\n  }\n\n  .ant-picker {\n    width: 100% !important;\n    min-height: 40px !important;\n    border-radius: 6px !important;\n  }\n\n  /* 表格响应式 */\n  .ant-table-wrapper {\n    overflow-x: auto;\n  }\n\n  .ant-table-container {\n    min-width: 600px;\n  }\n\n  /* 卡片网格布局 */\n  .ant-row {\n    margin: 0 -8px !important;\n  }\n\n  .ant-col {\n    padding: 0 8px !important;\n  }\n\n  /* 抽屉优化 */\n  .ant-drawer-content {\n    background: #161b22 !important;\n  }\n\n  .ant-drawer-header {\n    background: #161b22 !important;\n    border-bottom: 1px solid #30363d !important;\n  }\n\n  .ant-drawer-title {\n    color: #e6edf3 !important;\n  }\n\n  .ant-drawer-close {\n    color: #e6edf3 !important;\n  }\n}\n\n/* 平板设备 */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .ant-card {\n    margin: 12px 0 !important;\n  }\n\n  .ant-btn {\n    min-height: 44px !important;\n  }\n\n  .ant-input {\n    min-height: 44px !important;\n  }\n}\n\n/* 大屏幕优化 */\n@media (min-width: 1025px) {\n  .ant-card {\n    margin: 16px 0 !important;\n  }\n}\n\n/* 横屏优化 */\n@media (max-width: 768px) and (orientation: landscape) {\n  .ant-modal {\n    margin: 10px auto !important;\n  }\n\n  .ant-btn {\n    min-height: 36px !important;\n  }\n\n  .ant-input {\n    min-height: 36px !important;\n  }\n}\n\n/* 小屏幕手机优化 */\n@media (max-width: 480px) {\n  .ant-btn {\n    font-size: 13px !important;\n    padding: 8px 12px !important;\n  }\n\n  .ant-card {\n    margin: 6px 0 !important;\n  }\n\n  .ant-space-item {\n    margin-bottom: 8px !important;\n  }\n\n  .ant-table {\n    font-size: 11px !important;\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    padding: 6px !important;\n  }\n}\n\n/* 触摸设备优化 */\n@media (hover: none) and (pointer: coarse) {\n  .ant-btn:hover {\n    background-color: inherit !important;\n  }\n\n  .ant-list-item:hover {\n    background-color: inherit !important;\n  }\n\n  .ant-table-tbody > tr:hover > td {\n    background-color: inherit !important;\n  }\n\n  .ant-card:hover {\n    box-shadow: inherit !important;\n  }\n}\n\n/* 高分辨率屏幕优化 */\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .ant-card {\n    border-width: 0.5px !important;\n  }\n\n  .ant-btn {\n    border-width: 0.5px !important;\n  }\n}\n\n/* 暗黑主题响应式优化 */\n@media (max-width: 768px) {\n  .ant-card {\n    background: #161b22 !important;\n    border: 1px solid #30363d !important;\n  }\n\n  .ant-btn {\n    border: 1px solid #30363d !important;\n  }\n\n  .ant-input {\n    background: #21262d !important;\n    border: 1px solid #30363d !important;\n    color: #e6edf3 !important;\n  }\n\n  .ant-select-selector {\n    background: #21262d !important;\n    border: 1px solid #30363d !important;\n    color: #e6edf3 !important;\n  }\n\n  .ant-modal-content {\n    background: #161b22 !important;\n  }\n\n  .ant-modal-header {\n    background: #161b22 !important;\n    border-bottom: 1px solid #30363d !important;\n  }\n\n  .ant-modal-title {\n    color: #e6edf3 !important;\n  }\n\n  .ant-modal-body {\n    color: #e6edf3 !important;\n  }\n}\n\n/* 响应式工具类 */\n.responsive-hide-mobile {\n  display: block;\n}\n\n.responsive-show-mobile {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .responsive-hide-mobile {\n    display: none !important;\n  }\n\n  .responsive-show-mobile {\n    display: block !important;\n  }\n}\n\n.responsive-hide-tablet {\n  display: block;\n}\n\n.responsive-show-tablet {\n  display: none;\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .responsive-hide-tablet {\n    display: none !important;\n  }\n\n  .responsive-show-tablet {\n    display: block !important;\n  }\n}\n\n/* 容器响应式 */\n.responsive-container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 16px;\n}\n\n@media (max-width: 768px) {\n  .responsive-container {\n    padding: 0 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .responsive-container {\n    padding: 0 8px;\n  }\n}\n\n/* 网格响应式 */\n.responsive-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n}\n\n@media (max-width: 768px) {\n  .responsive-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .responsive-grid {\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
